// extracted by mini-css-extract-plugin
module.exports = {"screen":"_screen_screen__22J17"};